module.exports = __webpack_public_path__ + "static/media/chart.2d4d1f31.png";